import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Card, CardBody, Modal, ModalBody, ModalHeader } from "reactstrap";
import authenticatedFetcher from "../../services/fetcher";
import LoadingSpinner from "../LoadingSpinner";
import { toastError, toastSuccess } from "../../utils/ToastConfig";

export default function CustomModalRubactecSincro(props) {
  const { toggle, open } = props;
  const [yearOptions, setYearOptions] = useState([]);
  const [monthsOptions, setMonthsOptions] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonths, setSelectedMonths] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  useEffect(() => {
    if (open) {
      setLoadingData(true);
      authenticatedFetcher({ path: "/actions-logs/list-years-months-for-sincro/" }).then((res) => {
        if (res && !res.error) {
          const years = Array.isArray(res.years) ? res.years : [];
          const months = Array.isArray(res.months) ? res.months : [];
          setYearOptions(years);
          setMonthsOptions(months);
          const defaultYear = years.find((y) => y.selected);
          if (defaultYear) setSelectedYear(defaultYear.pk);
          setSelectedMonths(months.filter((m) => m.selected).map((m) => m.pk));
        }
        setLoadingData(false);
      });
    }
  }, [open]);

  useEffect(() => {
    if (!open) {
      setSelectedYear("");
      setSelectedMonths([]);
    }
  }, [open]);

  const handleYearChange = ({ target: { value } }) => {
    setSelectedYear(value);
  };

  const handleMonthToggle = (pk) => {
    setSelectedMonths((prev) =>
      prev.includes(pk) ? prev.filter((m) => m !== pk) : [...prev, pk]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingSubmit(true);

    try {
      const res = await authenticatedFetcher({
        path: "/actions-logs/sincro-sage-complete/",
        method: "POST",
        body: { year: selectedYear, months: selectedMonths },
      });

      const message = res.response || res.error_data?.response;
      const text = Array.isArray(message) ? message.join(". ") : message;

      if (!res.error) {
        toastSuccess(text || "Sincronització realitzada correctament", { autoClose: !(res.print_fixed_message_response) });
        setLoadingSubmit(false);
        setSelectedYear("");
        setSelectedMonths([]);
        toggle();
      } else {
        const errorText = Array.isArray(res.error_data?.response) ? res.error_data.response.join(". ") : res.error_data?.response || res.error;
        toastError(errorText || "Error en la sincronització", { autoClose: false });
        setLoadingSubmit(false);
      }
    } catch (error) {
      toastError(error.message || "Error en la sincronització", { autoClose: false });
      setLoadingSubmit(false);
    }
  };

  const isSubmitDisabled = !selectedYear || selectedMonths.length === 0 || loadingSubmit;

  return (
    <Modal size="md" toggle={toggle} isOpen={open} className="persona">
      <ModalHeader toggle={toggle} charCode="x">
        Sincro completa amb el SIE/SAGE
      </ModalHeader>
      <ModalBody>
        <Card>
          <CardBody>
            <form onSubmit={handleSubmit}>
              <div className="card-body">
                {loadingData ? (
                  <div className="d-flex justify-content-center py-3">
                    <LoadingSpinner show />
                  </div>
                ) : (
                  <>
                    <Form.Group className="row">
                      <Form.Label className="BasicLabel right mb-0 col-1">
                        Any:
                      </Form.Label>
                      <Form.Control
                        className="BasicInput col-9"
                        as="select"
                        name="year"
                        value={selectedYear}
                        onChange={handleYearChange}
                        required
                      >
                        {yearOptions.map((item) => (
                          <option key={item.pk} value={item.pk}>
                            {item.name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                    <Form.Group className="row mt-3">
                      <Form.Label className="BasicLabel right mb-0 col-1">
                        Mesos:
                      </Form.Label>
                      <div className="col-9">
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "4px" }}>
                          {monthsOptions.map((item) => (
                            <Form.Check
                              key={item.pk}
                              type="checkbox"
                              label={item.name}
                              checked={selectedMonths.includes(item.pk)}
                              onChange={() => handleMonthToggle(item.pk)}
                            />
                          ))}
                        </div>
                      </div>
                    </Form.Group>
                  </>
                )}
                <div className="w-100 my-3">
                  <Button
                    type="submit"
                    variant="secondary ml-auto d-block"
                    className="submitButton"
                    disabled={isSubmitDisabled}
                  >
                    Realitzar sincro
                    <LoadingSpinner show={loadingSubmit} />
                  </Button>
                </div>
              </div>
            </form>
          </CardBody>
        </Card>
      </ModalBody>
    </Modal>
  );
}
